/**
 * @author zk
 * @description 公共配置页面配置
 * @Date 2019/12/28
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../tool';
import {Divider} from "antd";
let { WizModal } = component_tool;

//配置项
let componentName = 'commonConfig'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "positionCategoryIds",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "orgIds",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "orgList",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "配置key",
    name: "configKey",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请选择配置key'
      }],
    },
  },
  {
    title: "配置内容",
    name: "configValue",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入配置内容'
      }]
    },
  },
  {
    title: "备注",
    name: "remarks",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输备注内容'
      }]
    },
  },
  {
    title: "配置状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: '启用' },
      { code: 0, codeName: '禁用' }
    ],
    searchItem: {
      type: 'select'
    }
  },


];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort:['add','delete','export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/common/commonConfig/commonConfigAdd'
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams:(rows,record,filters,callback)=>{
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort:['enable','update'],
      rowOperateView: [
        {
          key: "enable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: { '1': '禁用', '0': '启用', }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
                }吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/common/commonConfig/commonConfigUpd"
            }
          }
        }
      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
